import { useCallback, useEffect, useRef, useState } from 'react';

const stickyRef = (defaultSticky = false) => {
  const [isSticky, setIsSticky] = useState(defaultSticky);
  const elementRef = useRef(null);

  const toggleSticky = useCallback(
    ({ bottom }) => {
      if (bottom < 0 && !isSticky) {
        setIsSticky(true);
      } else if (isSticky && window.scrollY < 500) {
        setIsSticky(false);
      }
      // if (
      //   window.innerHeight + window.scrollY + 100 >=
      //     document.body.offsetHeight &&
      //   window.innerWidth < 1000
      // ) {
      //   setIsSticky(false);
      // }
    },
    [isSticky]
  );
  useEffect(() => {
    const handleScroll = () => {
      if (elementRef.current) {
        toggleSticky(elementRef.current.getBoundingClientRect());
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [toggleSticky]);
  return { elementRef, isSticky };
};
export default stickyRef;
